import { Box, Toolbar, Tooltip, Typography, Autocomplete, TextField, } from '@mui/material'
import Logo from '../../assets/logo.png';
import './Header.css';
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import Dropdown from '../common/Dropdown';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setHeaderRole } from '../../redux/actions/setRoleStore';
import { setSelectedRegion, setSelectedPlant } from '../../redux/actions/setRegionPlantStore';
import { getPlantRegionDetailsEndpoint } from '../../common/endpoints';
import { getPlantsRegionSlice } from '../../redux/actions/getPlantsRegionSlice';


const Header = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const cardTitle = localStorage.getItem("cardTitle");
  const roleDetails = useSelector((state) => state?.setRoleStore?.selectedRole);
  const [selectedRole, setSelectedRole] = useState(roleDetails);
  const selectedRegion = useSelector((state) => state?.setRegionPlantStore?.selectedRegion);
  const selectedPlant = useSelector((state) => state?.setRegionPlantStore?.selectedPlant);
  const [regionPlantData, setRegionPlantData] = useState([]);

  const getRegionPlantDetails = async () => {
    try {
      const responseRegionAndPlantData = await dispatch(getPlantsRegionSlice({
        dynamicEndpoint: `${getPlantRegionDetailsEndpoint}`,
      }));

      if (responseRegionAndPlantData?.meta?.requestStatus === 'fulfilled') {
        const apiData = responseRegionAndPlantData?.payload;
        setRegionPlantData(apiData ?? []);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  useEffect(() => {
    getRegionPlantDetails()
  }, [])

  useEffect(() => {
    if (regionPlantData.length > 0) {
      const savedRegion = localStorage.getItem("selectedRegion");
      const savedPlant = localStorage.getItem("selectedPlant");

      if (savedRegion) {
        dispatch(setSelectedRegion(savedRegion));
      } else {
        const firstRegion = regionPlantData[0];
        dispatch(setSelectedRegion(firstRegion.regionName));
      }

      if (savedPlant) {
        dispatch(setSelectedPlant(savedPlant));
      } else {
        const firstRegion = regionPlantData[0];
        if (firstRegion.plants.length > 0) {
          dispatch(
            setSelectedPlant(
              `${firstRegion.plants[0].plant} - ${firstRegion.plants[0].plantName}`
            )
          );
        }
      }
    }
  }, [regionPlantData, dispatch]);

  const handleChangeRoleDropdown = (value) => {
    localStorage.setItem("selectedRole", value);
    dispatch(setHeaderRole(value))
    setSelectedRole(value)
  }

  const handleChangePlantDropdown = (value) => {
    dispatch(setSelectedPlant(value));
    localStorage.setItem("selectedPlant", value);
  };

  const handleChangeRegionDropdown = (value) => {
    dispatch(setSelectedRegion(value));
    localStorage.setItem("selectedRegion", value);

    const plants = regionPlantData.find(r => r.regionName === value)?.plants || [];

    if (plants.length > 0) {
      const plantValue = `${plants[0].plant} - ${plants[0].plantName}`;

      dispatch(setSelectedPlant(plantValue));
      localStorage.setItem("selectedPlant", plantValue);
    } else {
      dispatch(setSelectedPlant(null));
      localStorage.removeItem("selectedPlant");
    }
  };

  const roles = ["Supplier", "Global Planner", "Supplier Admin", "Application Admin"];

  const userName = localStorage.getItem("userName");
  const userRole = localStorage.getItem("userRole");
  const regionOptions = regionPlantData.map(r => r.regionName);

  const selectedRegionData = regionPlantData.find(
    (r) => r.regionName === selectedRegion
  );

  const plantOptions = selectedRegionData
    ? selectedRegionData.plants.map(
      (p) => `${p.plant} - ${p.plantName}`
    )
    : [];

  const isRegionalPlanner = userRole === "Regional Planner" || userRole === "Regional Viewer";
  const role = userRole || props.userRole;
  const plannerRoles = ["Regional Planner"];
  const regionalViewerRoles = ["Regional Viewer"];
  const displayRole =
  plannerRoles.includes(role)
    ? "Regional Planner"
    : role === "Global Planner"
      ? "Global Planner"
      : role === "Global Viewer"
        ? "Global Viewer"
        : regionalViewerRoles.includes(role)
          ? "Regional Viewer"
          : role;


  return (
    <div className="main-header" ref={props?.headerRef}>
      <Toolbar className='toolbar_header'>
        <div className="main-box">
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip>
              <Box sx={{ textAlign: 'right' }}>
                <Box >
                  <Typography sx={{ mb: 1, fontSize: '13px' }}>
                    {`${userName} - ${displayRole}`}
                  </Typography>
                  {/* <div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 13 }}>
                    <span>Role: </span>
                    <Autocomplete
                      disableClearable // removes "X"
                      disablePortal
                      options={roles}
                      value={selectedRole}
                      onChange={(event, newValue) => handleChangeRoleDropdown(newValue)}
                      sx={{
                        width: 100,
                        "& .MuiOutlinedInput-root": {
                          padding: "2px 8px",
                          borderRadius: "6px",
                          backgroundColor: "#fff", // white box on dark background
                          color: "#000",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ccc",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#888",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#000",
                          fontSize: "1rem",
                        },
                        "& .MuiInputBase-input": {
                          padding: "4px 0",
                          fontSize: "14px",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            readOnly: true,
                            style: {
                              color: "#000",
                            },
                          }}
                        />
                      )}
                      slotProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-listbox": {
                              padding: 0,
                              textAlign: "left",
                            },
                            "& .MuiAutocomplete-option": {
                              justifyContent: "flex-start",
                              paddingLeft: "8px",
                            },
                          },
                        },
                      }}
                    />
                  </div> */}
                </Box>
                <Box sx={{ flexGrow: 0 }}>

                  <div className="header-actions" style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between", // 🔥 IMPORTANT
                    width: "100%",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      {isRegionalPlanner && (
                        <>
                          <span className="dropdown-label">Region:</span>
                          <Autocomplete
                            disableClearable // removes "X"
                            disablePortal
                            options={regionOptions}
                            value={selectedRegion}
                            onChange={(event, newValue) => handleChangeRegionDropdown(newValue)}
                            sx={{
                              width: 100,
                              "& .MuiOutlinedInput-root": {
                                padding: "2px 8px",
                                borderRadius: "6px",
                                backgroundColor: "#fff", // white box on dark background
                                color: "#000",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#ccc",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#888",
                              },
                              "& .MuiSvgIcon-root": {
                                color: "#000",
                                fontSize: "1rem",
                              },
                              "& .MuiInputBase-input": {
                                padding: "4px 0",
                                fontSize: "14px",
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  readOnly: true,
                                  style: {
                                    color: "#000",
                                  },
                                }}
                              />
                            )}
                            slotProps={{
                              popper: {
                                sx: {
                                  "& .MuiAutocomplete-listbox": {
                                    padding: 0,
                                    textAlign: "left",
                                  },
                                  "& .MuiAutocomplete-option": {
                                    justifyContent: "flex-start",
                                    paddingLeft: "8px",
                                  },
                                },
                              },
                            }}
                          />
                          <span className="dropdown-label">Plant:</span>
                          <Autocomplete
                            disableClearable // removes "X"
                            disablePortal
                            options={plantOptions}
                            value={selectedPlant}
                            onChange={(event, newValue) => handleChangePlantDropdown(newValue)}
                            sx={{
                              width: 150,
                              "& .MuiOutlinedInput-root": {
                                padding: "2px 8px",
                                borderRadius: "6px",
                                backgroundColor: "#fff", // white box on dark background
                                color: "#000",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#ccc",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#888",
                              },
                              "& .MuiSvgIcon-root": {
                                color: "#000",
                                fontSize: "1rem",
                              },
                              "& .MuiInputBase-input": {
                                padding: "4px 0",
                                fontSize: "14px",
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  readOnly: true,
                                  style: {
                                    color: "#000",
                                  },
                                }}
                              />
                            )}
                            slotProps={{
                              popper: {
                                sx: {
                                  "& .MuiAutocomplete-listbox": {
                                    padding: 0,
                                    textAlign: "left",
                                  },
                                  "& .MuiAutocomplete-option": {
                                    justifyContent: "flex-start",
                                    paddingLeft: "8px",
                                  },
                                },
                              },
                            }}
                          />
                        </>
                      )}
                    </div>
                    {location.pathname !== "/login" && <div>
                      <button onClick={props.handleLogout} className='logoutCustomButton'>Log Out</button>
                    </div>}

                  </div>

                </Box>
              </Box>
            </Tooltip>
          </Box>
        </div>
      </Toolbar>
      <div className='gradient_section'>
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {process.env.REACT_APP_ENV === "dev" ?
            "Development Environment - This is not Production. Use only for testing & development"
            : process.env.REACT_APP_ENV === "test" ?
              "UAT Environment - This is not Production. Use only for user acceptance testing"
              : process.env.REACT_APP_ENV === "uat" ?
                "UAT Environment - This is not Production. Use only for user acceptance testing"
                : process.env.REACT_APP_ENV === "prod" ?
                  ""
                  : ""}
        </span>
      </div>
    </div>
  );
}

export default Header